import { render, staticRenderFns } from "./DropdownSidebar.vue?vue&type=template&id=7b249137&scoped=true&lang=pug"
import script from "./DropdownSidebar.vue?vue&type=script&lang=js"
export * from "./DropdownSidebar.vue?vue&type=script&lang=js"
import style0 from "./DropdownSidebar.vue?vue&type=style&index=0&id=7b249137&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b249137",
  null
  
)

export default component.exports